import {
  JCodeDocuments,
  MedicalPaOrder,
} from "../../../data-model/medicalPaOrdersModel";
import { getAllJCodes } from "./existingDocsToLs";

export const getAllUniqueDocsFromJCodesInFlattenedArray = (
  medicalPaOrder: MedicalPaOrder,
): JCodeDocuments[] => {
  if (!medicalPaOrder) return [];
  const jcodes = getAllJCodes(medicalPaOrder ?? {});
  const docsFromEveryJcodes = jcodes
    ?.map((jcode) => jcode.documents)
    .flat()
    .filter((doc): doc is JCodeDocuments => doc !== undefined && doc !== null);

  const uniqueDocs: JCodeDocuments[] = Array.from(
    new Map(
      docsFromEveryJcodes?.map((doc) => [doc.doc_path, doc]) ?? [],
    ).values(),
  );
  return uniqueDocs ?? [];
};
